import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid="payment-cancel-page">
      <Card className="w-full max-w-lg p-10 text-center border-black/10">
        <span className="h-14 w-14 mx-auto grid place-items-center rounded-full bg-muted text-muted-foreground">
          <XCircle className="h-8 w-8" />
        </span>
        <h1 className="mt-6 font-display text-2xl font-bold">Paiement annulé</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Aucun débit n'a été effectué. Vous pouvez revenir aux tarifs à tout moment.
        </p>
        <div className="mt-8 flex flex-col gap-2">
          <Link to="/pricing"><Button className="w-full rounded-full h-11">Revoir les tarifs</Button></Link>
          <Link to="/dashboard" className="text-sm text-primary hover:underline">Retour au tableau de bord</Link>
        </div>
      </Card>
    </div>
  );
}
